import { motion, useInView } from "framer-motion"
import { graphql } from "gatsby"
import React, { useEffect, useRef, useState } from "react"
import parse from "html-react-parser";

const Testimonials = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const contentWithoutPTags = module.selectTestimonial.content.replace(
    /<p>|<\/p>/g,
    ""
  )

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`testimonials pb-[270px] relative pt-130 mdscreen:pt-80 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <img
            src="../../images/giraffe.jpg"
            alt="giraffe"
            height={1440}
            width={482}
            loading="lazy"
            className="absolute bottom-0 left-0 h-full w-full object-cover object-center"
          />
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid relative z-10"
          >
            <motion.div variants={animFade} className="icon">
              <img
                src="../../images/grey-ring.svg"
                alt="grey-ring"
                height={48}
                width={48}
                className="w-[48px] h-[48px] mx-auto"
              />
            </motion.div>
            <div className="testimonials-main max-w-[1037px] mx-auto pt-40">
              <motion.div variants={animFade} className="content">
                <p>“{parse(contentWithoutPTags)}”</p>
              </motion.div>
              <motion.div variants={animFade} className="user-name pt-45">
                <ul>
                  <li>{module.selectTestimonial.title}</li>
                  <li>{module.selectTestimonial.testimonial.country}</li>
                  <li>{module.selectTestimonial.testimonial.lodge}</li>
                </ul>
              </motion.div>
            </div>
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
}

export default Testimonials
export const PageTestimonialsFragment = graphql`
  fragment PageTestimonialsFragment on WpPage_Pagecontent_PageContent_Testimonials {
    extraClass
    extraId
    hideSection
    selectTestimonial {
      ... on WpTestimonial {
        id
        title
        content
        testimonial {
          country
          lodge
        }
      }
    }
  }
`
export const CampTestimonialsFragment = graphql`
  fragment CampTestimonialsFragment on WpCamp_Campcontent_CampContent_Testimonials {
    extraId
    extraClass
    hideSection
    selectTestimonial {
      ... on WpTestimonial {
        id
        title
        content
        testimonial {
          country
          lodge
        }
      }
    }
  }
`

export const ItinerariesTestimonialsFragment = graphql`
  fragment ItinerariesTestimonialsFragment on WpItineraries_Itinerariescontent_ItinerariesContent_Testimonials {
    extraId
    extraClass
    hideSection
    selectTestimonial {
      ... on WpTestimonial {
        id
        title
        content
        testimonial {
          country
          lodge
        }
      }
    }
  }
`
export const ExperienceTestimonialsFragment = graphql`
  fragment ExperienceTestimonialsFragment on WpExperiences_Experiencecontent_ExperienceContent_Testimonials {
    extraId
    extraClass
    hideSection
    selectTestimonial {
      ... on WpTestimonial {
        id
        title
        content
        testimonial {
          country
          lodge
        }
      }
    }
  }
`
export const DestinationTestimonialsFragment = graphql`
  fragment DestinationTestimonialsFragment on WpDestination_Destinationcontent_DestinationContent_Testimonials {
    extraId
    extraClass
    hideSection
    selectTestimonial {
      ... on WpTestimonial {
        id
        title
        content
        testimonial {
          country
          lodge
        }
      }
    }
  }
`
